import { Inject, Injectable } from '@angular/core';
import { QuantityPipe, SystemOfUnits } from 'ng-units';
import { UserService } from './user.service';
import { Observable, Subject, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { UnitSetting, Quantity,Preset} from './units-datatypes';
import { RestDataService } from './rest-data.service';

@Injectable({
  providedIn: 'root'
})

export class UnitsService {

  quantityPipe: QuantityPipe;

  public static PRESETS = [Preset.PRESET_EUROPEAN, Preset.PRESET_US, Preset.PRESET_SI, Preset.PRESET_CUSTOM];
  private unitSetting: UnitSetting;
  private unitChangeAnnouncedSource = new Subject<{quantityName:string;fromUnit:string;toUnit:string}>();
  public unitChangeAnnounced = this.unitChangeAnnouncedSource.asObservable();
  private unitServiceStateSource = new Subject<string>();
  public unitServiceState = this.unitServiceStateSource.asObservable();
  private checkedSavedSettings = false;
  private savedSettings = false;
  private presetSettings = new Map();
  public static quantity = Quantity;
  public preset = Preset;
  private unitsUrl;

  constructor(private systemOfUnits: SystemOfUnits, private userService:UserService,private restDataService:RestDataService,@Inject('app_config') private environment:any) {
    this.quantityPipe = new QuantityPipe(systemOfUnits);
    this.presetSettings = new Map();
    this.presetSettings.set(Preset.PRESET_EUROPEAN,Preset.PRESET_EUROPEAN_SETTINGS);
    this.presetSettings.set(Preset.PRESET_US,Preset.PRESET_US_SETTINGS);
    this.presetSettings.set(Preset.PRESET_SI,Preset.PRESET_SI_SETTINGS);
    this.unitsUrl = this.environment.app_config ? this.environment.app_config.unitsURL : this.environment.unitsURL;
    //this.setAsPreset(Preset.PRESET_SI);
  }

  setAsPreset(preset:string,silent?:boolean) {
    if(preset != Preset.PRESET_CUSTOM) {
      this.presetSettings.get(preset).forEach(setting => {
         this.setUnitForQuantity(setting[0],setting[1]);
      });
    }
    this.flushSystemOfUnits();
    this.unitSetting.preset = preset;
    if(silent) return;
    this.unitChangeAnnouncedSource.next({quantityName:"all",fromUnit:null,toUnit:null});
  }

  getUnitsForQuantity(quantityName: string): string[] {
    let units = [];
    this.systemOfUnits.quantities.find(quantity => { return quantity.name === quantityName }).units.forEach(unit => { units.push(unit.symbol) })
    return units;
  }

  getSelectedUnitForQuantity(quantityName: string) {
    if(!quantityName) return "";
    return this.systemOfUnits.quantities.find(quantity => { return quantity.name === quantityName }).unit.symbol;
  }

  setUnitForQuantity(quantityName: string, unit: string, intialisingCustomPreset?:boolean) {
    if (this.getSelectedUnitForQuantity(quantityName) != unit && !intialisingCustomPreset) { this.setAsPreset("Custom"); }
    this.systemOfUnits.selectUnit(this.systemOfUnits.quantities.find(quantity => { return quantity.name === quantityName }), unit);
  }

  private flushSystemOfUnits() {
    this.unitSetting = {
      _id: this.unitSetting && this.unitSetting._id ? this.unitSetting._id : null,
      pressure: this.getSelectedUnitForQuantity(Quantity.PRESSURE),
      throughput: this.getSelectedUnitForQuantity(Quantity.THROUGHPUT),
      throughputMolarFlow: this.getSelectedUnitForQuantity(Quantity.THROUGHPUT_MOLAR_FLOW),
      throughputMassFlow: this.getSelectedUnitForQuantity(Quantity.THROUGHPUT_MASS_FLOW),
      frequency: this.getSelectedUnitForQuantity(Quantity.FREQUENCY),
      power: this.getSelectedUnitForQuantity(Quantity.POWER),
      length: this.getSelectedUnitForQuantity(Quantity.LENGTH),
      xDim: this.getSelectedUnitForQuantity(Quantity.XDIM),
      speed: this.getSelectedUnitForQuantity(Quantity.SPEED),
      preset: this.unitSetting && this.unitSetting.preset ? this.unitSetting.preset : null,
      area:this.getSelectedUnitForQuantity(Quantity.AREA),
      volume:this.getSelectedUnitForQuantity(Quantity.VOLUME),
      time:this.getSelectedUnitForQuantity(Quantity.TIME),
      temperature:this.getSelectedUnitForQuantity(Quantity.TEMPERATURE),
      outgassing: this.getSelectedUnitForQuantity(Quantity.OUTGASSING),
    }
  }

  convertFromSIForQuantity(quantityName: string, value: number):number {
    return this.systemOfUnits.get(quantityName).fromBase(value);
  }

  convertToSIForQuantity(quantityName: string, value: number) {
    return this.systemOfUnits.get(quantityName).toBase(value);
  }

  setUnitForQuantityAndAnnounce(quantityName: string, unit: string) {
    let fromUnit = this.getSelectedUnitForQuantity(quantityName);
    this.setUnitForQuantity(quantityName, unit,true);
    this.setAsPreset(this.getPresetForUnitSelection(),true);
    this.announceUnitChange({quantityName:quantityName,fromUnit:fromUnit,toUnit:unit});
  }



  // convertValueFromGivenUnitToSI(quantityName: string, givenUnitName: string, value: number): number {
  //   let unit: any = this.systemOfUnits.get(quantityName).findUnit(givenUnitName);
  //   if (unit && unit.factor != 0) {
  //     return (value + unit.offset) / unit.factor;
  //   } else {
  //     return null;
  //   }
  // }

  // convertValueFromGivenUnitToSelectedUnit(quantityName: string, givenUnitName: string, value: number): number {
  //   let valueInSI = this.convertValueFromGivenUnitToSI(quantityName, givenUnitName, value);
  //   if (valueInSI) {
  //     return this.convertFromSIForQuantity(quantityName, valueInSI);
  //   } else {
  //     return null;
  //   }
  // }

  init(): Observable<any> {
    return this.hasSavedSettings().pipe(map(hasSettings => {
      if (hasSettings) {
        return of(this.unitSetting);
      }
      else {
        this.setAsPreset("European");
        this.unitServiceStateSource.next("ready");
      }
    }))
    // .catch(err => {
    //   console.log(err);
    //   throw (err);
    // })
  }

  saveSettings(): Observable<any> {
    this.flushSystemOfUnits();
    this.savedSettings=true;
    if (this.unitSetting._id) {
      return this.putUnitSetting(this.unitSetting, this.userService.getUserId()).pipe(map(result => { return this.unitSetting }));
    }
    else {
      this.unitSetting.userId = this.userService.getUserId();
      return this.postUnitSetting(this.unitSetting).pipe(map(result => { this.unitSetting = result; this.savedSettings = true; return this.unitSetting }));
    }
  }

  hasSavedSettings(): Observable<boolean> {
    if (this.checkedSavedSettings) { return of(this.savedSettings) }
    return this.getUnitSetting(this.userService.getUserId()).pipe(map((unitSetting: any) => {
      this.savedSettings = true;
      this.checkedSavedSettings = true;
      this.unitSetting = unitSetting;
      if (this.unitSetting.preset == Preset.PRESET_CUSTOM) {
        this.setUnitForQuantity(Quantity.PRESSURE, this.unitSetting.pressure,true);
        this.setUnitForQuantity(Quantity.THROUGHPUT, this.unitSetting.throughput,true);
        this.setUnitForQuantity(Quantity.THROUGHPUT_MOLAR_FLOW, this.unitSetting.throughputMolarFlow,true);
        this.setUnitForQuantity(Quantity.THROUGHPUT_MASS_FLOW, this.unitSetting.throughputMassFlow,true);
        this.setUnitForQuantity(Quantity.FREQUENCY, this.unitSetting.frequency,true);
        this.setUnitForQuantity(Quantity.POWER, this.unitSetting.power,true);
        this.setUnitForQuantity(Quantity.LENGTH, this.unitSetting.length,true);
        this.setUnitForQuantity(Quantity.XDIM, this.unitSetting.xDim,true);
        this.setUnitForQuantity(Quantity.SPEED, this.unitSetting.speed,true);
        this.setUnitForQuantity(Quantity.AREA,this.unitSetting.area,true);
        this.setUnitForQuantity(Quantity.VOLUME,this.unitSetting.volume,true);
        this.setUnitForQuantity(Quantity.TIME,this.unitSetting.time,true);
        this.setUnitForQuantity(Quantity.TEMPERATURE,this.unitSetting.temperature,true);
        this.setUnitForQuantity(Quantity.POWER,this.unitSetting.power,true);
        this.setUnitForQuantity(Quantity.OUTGASSING,this.unitSetting.outgassing,true);
      } else {
        this.setAsPreset(this.unitSetting.preset);
      }
      this.unitServiceStateSource.next("ready");
      this.unitChangeAnnouncedSource.next({quantityName:"all",fromUnit:null,toUnit:null});
      return this.savedSettings;
    })

    // .catch(err => {
    //   this.checkedSavedSettings = true;
    //   //if no unit setting then create and save one
    //   if (err.status && err.status == 404) {
    //     this.savedSettings = false;
    //     return of(false);
    //   }
    //   else throw (err);
    // })

    );
  }

  public getPreset() {
    return this.unitSetting ? this.unitSetting.preset : null;
  }

  getPresetForUnitSelection() {
    let result = Preset.PRESET_CUSTOM;
    Array.from(this.presetSettings.keys()).forEach( preset => {
      let match=true;
      this.presetSettings.get(preset).forEach(setting => {
        if(this.getSelectedUnitForQuantity(setting[0]) != setting[1]) {match=false;return;}
      });
      if(match){result = preset};
      return;
    });
    return result;
  }

  getThroughPutUnitAsSpeedxPressure(){
    let throughputUnits = this.getUnitsForQuantity(Quantity.THROUGHPUT);
    let selectedThroughputUnit = null;
    throughputUnits.forEach(unit => {
      if(selectedThroughputUnit) {return;}
      if(unit.indexOf( this.getSelectedUnitForQuantity(Quantity.SPEED)) > -1  && unit.indexOf(this.getSelectedUnitForQuantity(Quantity.PRESSURE)) > -1 ){
        selectedThroughputUnit = unit;
      }
    })
    return selectedThroughputUnit;
  }

  postUnitSetting(unitSetting:UnitSetting):Observable<any>{
    return this.restDataService.post(this.unitsUrl,unitSetting);
  }

  putUnitSetting(unitSetting:UnitSetting, userID:string):Observable<any>{
    return this.restDataService.put(this.unitsUrl + "/" + userID,unitSetting);
  }

  getUnitSetting(userID:string):Observable<any> {
    return this.restDataService.get<any>(this.unitsUrl + '/' + userID);
  }

  reload():Observable<any>{
    this.checkedSavedSettings = false;
    this.savedSettings = false;
    return this.init();
  }

  announceUnitChange(change:{quantityName:string,fromUnit:string,toUnit:string}){
    this.unitChangeAnnouncedSource.next(change);
  }

}


//todo error catch on REST calls for get setting